import { ClassAttributes, SelectHTMLAttributes, useContext, useMemo } from 'react'
import { JSX } from 'react/jsx-runtime'
import { AuthContext } from '../contexts/Auth/AuthProvider'

export const OrgSelect = (
  selectProps: JSX.IntrinsicAttributes & ClassAttributes<HTMLSelectElement> & SelectHTMLAttributes<HTMLSelectElement>,
) => {
  const { user, activeOrganization, setActiveOrganization } = useContext(AuthContext)
  const options = useMemo(() => {
    if (!user) return []
    return user.orgs.map((org) => (
      <option key={org.id} value={org.id}>
        {org.name}
      </option>
    ))
  }, [user])
  const onChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    if (!setActiveOrganization) return
    const orgId = event.target.value
    setActiveOrganization(orgId)
  }
  return (
    <select {...selectProps} onChange={onChange} value={activeOrganization}>
      {options}
    </select>
  )
}
